import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Uppy from '@uppy/core';
import DragDrop from '@uppy/drag-drop';
import Tus from '@uppy/tus';
import "./ItemCard.scss";

/**
 * The AddItem component is a simple wrapper for the add item icon show at the end of the cards.
 * It calls @UploadModalContent to open the modal for uploading a new item.
 */
class AddItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount && super.componentDidMount();
  }

  onClickContainer = e => {
    e.preventDefault();
    this.props.onClick();
  }

  render() {
    return (
      <div className="additem" onClick={this.onClickContainer}>
        {/* <Link to='/upload'> */}
          <div className={`item-card-container add ${this.props.horizontal ? 'horizontal' : 'vertical'}`}>
            <FontAwesomeIcon icon={faPlus} />
            <div className="for-add-dragAndDrop"></div>
          </div>
        {/* </Link> */}
      </div>
    )
  }
}

export default AddItem;
